<template>
  <div>
    <NBar title="修改登录密码"/>
    <nut-textinput placeholder="旧密码" v-model="pwd" type="password" :clearBtn="false" :has-border="false"/>
    <nut-textinput placeholder="新密码" v-model="newPwd" type="password" :clearBtn="false" :has-border="false"/>
    <nut-textinput placeholder="确认密码" v-model="checkPwd" type="password" :clearBtn="false" :has-border="false"/>
    <nut-button style="margin: 15px 15px 60px 15px;border-radius: 5px;width:92%;" @click="save">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'Password',
  data () {
    return {
      pwd: '',
      newPwd: '',
      checkPwd: ''
    }
  },
  methods: {
    save () {
      let that = this
      let pwd = this.pwd
      let newPwd = this.newPwd
      let checkPwd = this.checkPwd
      if (pwd == '') {
        this.$toast.warn('请输入旧密码')
        return
      }
      if (newPwd == '') {
        this.$toast.warn('请输入新密码')
        return
      }
      if (checkPwd == '') {
        this.$toast.warn('请再次输入新密码')
        return
      }
      if (newPwd != checkPwd) {
        this.$toast.warn('2次输入的新密码不同')
        return
      }
      this.$api.post({
        url: '/device/api/device/device-account/updatePwd',
        data: {
          merId: this.$api.user.merId,
          id: this.$api.user.uid,
          password: pwd,
          newPwd: newPwd,
        }
      }).then(res => {
        this.$dialog({
          content: '密码已修改,请重新登陆',
          closeBtn: true,  //显式右上角关闭按钮
          noOkBtn: true,
          cancelBtnTxt: '确定',
          onCancelBtn (event) {  //取消按钮点击事件，默认行为关闭对话框
            localStorage.removeItem('token')
            that.$router.push('/device/login')
          },
          onCloseBtn (event) { //右上角关闭按钮点击事件
            localStorage.removeItem('token')
            this.$router.push('/device/login')
          },
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/Password.vue